import React from 'react';
import GoogleMapReact from 'google-map-react';

function createMapOptions(maps) {
  return {
    fullscreenControl: false,
    mapTypeControl: true,
    streetViewControl: true
  };
}

/* *** NOTE: Theme Provider will need to be redefined for top level child that is wrapped by GoogleMapReact */
export function GoogleMapsReactWrap(_ref) {
  var children = _ref.children,
      center = _ref.center,
      zoom = _ref.zoom;
  return /*#__PURE__*/React.createElement(GoogleMapReact, {
    bootstrapURLKeys: {
      key: process.env.GOOGLE_MAPS_GEOCODING_API_KEY
    },
    center: center,
    defaultZoom: zoom,
    options: createMapOptions
  }, children);
}